// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2V3sz","total":"Cart_total__3Qb6w","actions":"Cart_actions__2dlFg","button--alt":"Cart_button--alt__1-GJ6","button":"Cart_button__Fu8YR"};